<div
  class="flex flex-col h-full border-r border-r-neutral-200 transition-all duration-100 ease-in-out overflow-x-hidden"
  [ngClass]="appService.navClosed ? 'w-[4.1rem]' : 'w-64'">
  <div class="flex flex-row items-center pt-7 pb-0" [ngClass]="appService.navClosed ? 'justify-center' : 'justify-between px-4'">
    <img
      src="../../../../assets/svg/logo.svg"
      class="w-[72px] cursor-pointer"
      *ngIf="!appService.navClosed"
      (click)="redirectToHomePage()"
      alt="Logo" />
    <flow-button class="" theme="light" type="button" (onClick)="toggleSidenav()">
      <app-icon stroke="#202020" size="md" iconName="hamburger"></app-icon>
    </flow-button>
  </div>

  <div class="flex-1 overflow-y-auto overflow-x-hidden p-4">
    <ng-container *ngFor="let sidnevParent of SIDENAV_MENU">
      <ng-container *ngIf="!appService.navClosed && sidnevParent?.label">
        <div
          *flowHasPermission="sidnevParent?.permissions; operation 'OR'"
          class="inline-flex my-2 text-zinc-600 text-xs font-medium font-['Inter'] uppercase leading-none">
          {{sidnevParent?.label | translate | uppercase}}
        </div>
      </ng-container>

      <ng-container *ngFor="let sidenavChild of sidnevParent.children" #ref>
        <div class="w-full mb-1" [ngClass]="appService.navClosed ? 'flex w-full justify-center items-center' : ''">
          <flow-sidenav-item
            *flowHasPermission="sidenavChild.permissions; operation 'OR'"
            [label]="sidenavChild?.label"
            [url]="sidenavChild.url"
            [iconName]="sidenavChild.iconName"
            [permissions]="sidenavChild.permissions"
            [navMini]="appService.navClosed"></flow-sidenav-item>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="flex flex-row px-2 pb-4" [ngClass]="appService.navClosed ? 'w-[4.1rem]' : 'w-64'">
    <div
      class="flex flex-row w-full items-center p-2 gap-2 cursor-pointer rounded transition-colors ease-in-out duration-100 hover:bg-neutral-100"
      [matTooltip]="currentUser?.email"
      matTooltipPosition="right"
      (click)="showSettings($event)">
      <span class="flex w-8 h-8 items-center justify-center rounded-full bg-brand-chathams-blue text-white">{{initials}}</span>

      <div class="flex flex-col min-w-0" *ngIf="!appService.navClosed">
        <ng-container *ngIf="selectedCustomer">
          <p class="m-0 text-sm font-semibold leading-4">{{selectedCustomer?.name}}</p>
          <p class="m-0 truncate min-w-0 leading-4">{{ currentUser?.fullName }}</p>
        </ng-container>
      </div>
    </div>

    <div flowClickOutside class="fixed z-50 bottom-20 left-3" *ngIf="showNavSettings" (clickOutside)="showNavSettings=false">
      <flow-nav-settings
        [adminUser]="adminUser"
        [currentUser]="currentUser"
        [initials]="initials"
        [customers]="customers"
        (customerChange)="onCustomerChange($event)"
        (closeNavSettings)="closeSettings($event)"></flow-nav-settings>
    </div>
  </div>
</div>
